import { render, staticRenderFns } from "./CotAllertPage.vue?vue&type=template&id=e9df3b48"
import script from "./CotAllertPage.vue?vue&type=script&lang=js"
export * from "./CotAllertPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports